/*!
=========================================================
* Painel Toca da Onça — Caixa & Vendas
=========================================================
* Mostra as vendas de balcão (PDV) que persistem no aparelho.
*/
import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Table, Badge } from "reactstrap";

const brl = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function Notifications() {
  const [vendas, setVendas] = React.useState([]);
  React.useEffect(() => {
    const local = () => {
      try { setVendas(JSON.parse(localStorage.getItem("vendas_pdv") || "[]")); } catch (e) {}
    };
    fetch("http://localhost:8787/vendas")
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (Array.isArray(d)) {
          setVendas(d.map((v) => ({
            data: (v.created_at || "").slice(0, 10),
            ts: new Date(v.created_at).getTime(),
            loja: v.loja, vendedor: v.vendedor, itens: v.itens || [],
            total: Number(v.total), pagamento: v.forma_pagamento,
          })));
        } else local();
      })
      .catch(local);
  }, []);

  const hoje = new Date().toISOString().slice(0, 10);
  const doDia = vendas.filter((v) => v.data === hoje);
  const totalDia = doDia.reduce((s, v) => s + v.total, 0);

  const porVendedor = {};
  doDia.forEach((v) => { porVendedor[v.vendedor] = (porVendedor[v.vendedor] || 0) + v.total; });

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>Caixa &amp; vendas</h3>
          <p className="text-muted">Vendas de balcão do dia, direto do PDV. Persistem no aparelho.</p>
        </Col>
      </Row>
      <Row>
        <Col lg="4" md="6">
          <Card className="card-stats"><CardBody>
            <p className="card-category text-muted">Caixa de hoje</p>
            <CardTitle tag="h2" className="text-success">{brl(totalDia)}</CardTitle>
          </CardBody></Card>
        </Col>
        <Col lg="4" md="6">
          <Card className="card-stats"><CardBody>
            <p className="card-category text-muted">Vendas de hoje</p>
            <CardTitle tag="h2" className="text-info">{doDia.length}</CardTitle>
          </CardBody></Card>
        </Col>
        <Col lg="4" md="6">
          <Card className="card-stats"><CardBody>
            <p className="card-category text-muted">Ticket médio</p>
            <CardTitle tag="h2" className="text-warning">{brl(doDia.length ? totalDia / doDia.length : 0)}</CardTitle>
          </CardBody></Card>
        </Col>
      </Row>

      {Object.keys(porVendedor).length > 0 && (
        <Row>
          <Col xs="12">
            <Card><CardHeader><CardTitle tag="h4">Caixa por vendedor</CardTitle></CardHeader>
              <CardBody>
                {Object.entries(porVendedor).map(([v, t]) => (
                  <div key={v} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,.06)" }}>
                    <span className="text-white">{v}</span>
                    <span className="text-success" style={{ fontWeight: 600 }}>{brl(t)}</span>
                  </div>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}

      <Row>
        <Col xs="12">
          <Card>
            <CardHeader><CardTitle tag="h4">Vendas de hoje ({doDia.length})</CardTitle></CardHeader>
            <CardBody>
              <Table className="tablesorter" responsive>
                <thead className="text-primary">
                  <tr><th>Hora</th><th>Loja</th><th>Vendedor</th><th>Itens</th><th>Pagamento</th><th className="text-right">Total</th></tr>
                </thead>
                <tbody>
                  {doDia.slice().reverse().map((v, i) => (
                    <tr key={i}>
                      <td>{new Date(v.ts).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}</td>
                      <td>{v.loja}</td>
                      <td>{v.vendedor}</td>
                      <td>{(v.itens || []).reduce((s, it) => s + it.qtd, 0)}</td>
                      <td><Badge color="primary" pill>{v.pagamento}</Badge></td>
                      <td className="text-right text-success" style={{ fontWeight: 600 }}>{brl(v.total)}</td>
                    </tr>
                  ))}
                  {doDia.length === 0 && <tr><td colSpan="6" className="text-muted">Nenhuma venda hoje. Registre no PDV.</td></tr>}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Notifications;
